import { render, staticRenderFns } from "./CustomUpload.vue?vue&type=template&id=51c74f7c&"
import script from "./CustomUpload.vue?vue&type=script&lang=js&"
export * from "./CustomUpload.vue?vue&type=script&lang=js&"
import style0 from "./CustomUpload.vue?vue&type=style&index=0&id=51c74f7c&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports